module Meevo.Components.Controls.SmartMover {
    import ProductCategory = Model.ProductCategory;


    export class ProductCategoriesCollection extends SmartMoverApiCollection<ProductCategory> implements IApiCollection<ProductCategory> {

        protected get smartMoverHiddenValue() {
            return SmartMoverHiddenValue.EmptyArray;
        }

        get url() {
            return 'productCategory';
        }
    }

}